export default "/images/40cdfa029fe7b3446c9a0a7d5b9db1fe.avif";